import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'switcher',
  templateUrl: './switcher.component.html',
  styleUrls: ['./switcher.component.scss']
})
export class SwitcherComponent {
  @Input() value: boolean;            // Input com nome 'value'
  @Output() valueChange = new EventEmitter<boolean>(); // Output com nome 'valueChange'
  @Input() disabled: boolean;

  toggleValue () {
    if (!this.disabled) this.valueChange.emit(!this.value);
  }
}
